import { Image, Container } from 'react-bootstrap'

import useWindowSize from '../../../utilities/useWindowSize'

// Assets
import img_encume_sm from '../../../assets/img/encume-sm.png'
import img_encume_md from '../../../assets/img/general/encume-md.png'
import logo_encume from '../../../assets/img/logos/logo-blanco-global.png'

// Styles
import '../../../styles/encume/encume.styles.scss'

const Encume = () => {
    const { width }  = useWindowSize()

    return (
        <section className='encume-hero'>
            <div className='encume-hero__image-container'>
                { width > 767 ? (
                    <Image src={img_encume_md} alt='EnCuMe encuentro' className='encume-hero__image' />
                ) : (
                    <Image src={img_encume_sm} alt='EnCuMe encuentro' className='encume-hero__image' />
                )}
                <div className='encume-hero__overlay'></div>
            </div>
            
            <div className='encume-hero__content'>
                <div className='encume-hero__logo-wrapper'>
                    <Image 
                        src={logo_encume}
                        alt='Logo La Vida en Rojo'
                        className='encume-hero__logo'
                    />
                </div>
                
                <Container className='encume-hero__text-container'>
                    <div className='encume-hero__text-box'>
                        <h2 className='encume-hero__title'>EnCuMe</h2>
                        <p className='encume-hero__paragraph'>
                            La Asociación de cultura menstrual, La Vida en Rojo nació de la voluntad de tejer red entre compañeras educadoras menstruales tras el I Encuentro nacional de Cultura Menstrual (EnCuMe) realizado en Barcelona en el año 2019. Este encuentro, junto con los sucesivos online (2020 y 2021) recogieron la necesidad individual y colectiva de compartir investigación, lenguaje, vivencias, y debatir sobre las políticas públicas, sanitarias y educativas que sobre el ciclo menstrual se aplican en el Estado español. Estos encuentros sirvieron como espacio compartido para reflexionar sobre los diversos temas socioculturales y económicos que condicionan la vida de las mujeres y personas menstruantes.
                        </p>
                        <a 
                            href='https://www.youtube.com/watch?v=lkb3WvWG1ss&t=6813s'
                            target='_blank'
                            rel='noopener noreferrer'
                            className='encume-hero__button'>
                            Ver EnCuMe online 2021 →
                        </a>
                    </div>
                </Container>
            </div>
        </section>
    )
}

export default Encume